class CaiProductOptions extends HTMLElement {
  connectedCallback() {
    if (this.dataset.caiReady === 'true') return;
    this.dataset.caiReady = 'true';
    this.unavailableControls = new WeakSet(this.querySelectorAll('[disabled]'));
    const stickyAddToCart = document.querySelector('sticky-add-to-cart');
    if (stickyAddToCart) {
      stickyAddToCart.dataset.caiSuppressed = 'true';
      stickyAddToCart.hidden = true;
    }
    this.addEventListener('change', () => this.#update());
    this.#update();
  }

  disconnectedCallback() {
    const stickyAddToCart = document.querySelector('sticky-add-to-cart[data-cai-suppressed="true"]');
    if (stickyAddToCart) {
      stickyAddToCart.hidden = false;
      delete stickyAddToCart.dataset.caiSuppressed;
    }
  }

  getCartItems(quantity = 1, parentVariantId, configuration) {
    return this.#selectedAddonControls().map((control) => ({
      variantId: control.dataset.addonVariantId,
      quantity,
      parentVariantId,
      properties: {
        'Add-on for': this.dataset.productTitle || 'Product configuration',
        ...(configuration ? { Configuration: configuration } : {}),
        [this.#propertyName(control)]: control.value,
      },
    }));
  }

  getAddonPropertyNames() {
    return this.#selectedAddonControls().map((control) => this.#propertyName(control));
  }

  #propertyName(control) {
    const name = control.tagName === 'OPTION' ? control.parentElement.name : control.name;
    return name.replace(/^properties\[/, '').replace(/\]$/, '');
  }

  #selectedAddonControls() {
    const checked = [...this.querySelectorAll('input[data-addon-variant-id]:checked:not(:disabled)')];
    const selected = [...this.querySelectorAll('select:not(:disabled)')]
      .map((select) => select.selectedOptions[0])
      .filter((option) => option?.dataset.addonVariantId && !option.disabled);
    return [...checked, ...selected];
  }

  #update() {
    const values = new Map();
    for (const control of this.querySelectorAll('[data-cai-key]')) {
      values.set(control.dataset.caiKey, control.value);
    }

    for (const group of this.querySelectorAll('[data-cai-show-when]')) {
      const [key, expected] = group.dataset.caiShowWhen.split('=');
      const visible = expected.split('|').includes(values.get(key));
      group.hidden = !visible;
      for (const control of group.querySelectorAll('input, select, textarea')) {
        control.disabled = !visible || this.unavailableControls.has(control);
        if (!visible) {
          if (control.type === 'checkbox' || control.type === 'radio') control.checked = false;
          else control.value = '';
          if (control.dataset.caiKey) values.set(control.dataset.caiKey, control.value);
        }
      }
    }

    const prewire = this.querySelector('[data-cai-key="prewire"]');
    const harness = this.querySelector('[data-cai-key="harness"]');
    if (prewire && harness) {
      harness.required = prewire.checked && !prewire.disabled;
      harness.setCustomValidity(harness.required && !harness.checked ? 'Please add the vehicle-specific harness required for CAI pre-wiring.' : '');
    }

    const total = this.#selectedAddonControls().reduce(
      (sum, control) => sum + Number(control.dataset.addonPrice || 0),
      0
    );
    const summary = this.querySelector('[data-cai-addon-summary]');
    if (summary) {
      summary.hidden = total === 0;
      summary.textContent = total === 0
        ? ''
        : `Selected add-ons per item: ${new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
            style: 'currency',
            currency: this.dataset.currency || 'USD',
          }).format(total / 100)}`;
    }
  }
}

if (!customElements.get('cai-product-options')) {
  customElements.define('cai-product-options', CaiProductOptions);
}
